import { useEffect } from 'react';
import PropTypes from 'prop-types';
import CCEvents, {
  EventNames,
  EventPropertyKeys,
} from '@companycam/companycam-events';

const SignUpStep = ({ children, currentStepName, stepName }) => {
  const logRegistrationProgress = (name) =>
    CCEvents.logEvent(EventNames.REGISTRATION_PROGRESS, {
      [EventPropertyKeys.REGISTRATION_STEP]: name,
    });

  useEffect(
    () => {
      if (currentStepName === stepName) logRegistrationProgress(stepName);
    },
    [currentStepName, stepName],
  );

  if (currentStepName === stepName) {
    return children;
  } else return null;
};

SignUpStep.propTypes = {
  children: PropTypes.object,
  currentStepName: PropTypes.string,
  stepName: PropTypes.string,
};

export default SignUpStep;
